/*
 * Created by: cparaschiv
 * Date: 13.12.2012, 17:26
 */

//ko.mapping.defaultOptions().ignore = ['events', '__ko_proto__', 'fn', '$caller', 'caller', '_events', 'equalityComparer'];
//ko.mapping.defaultOptions().ignore = ['__ko_mapping__'];

TS.Log = TS.Log || {};

(function(){
    'use strict';

    var internalProps = [TS.Constants.ownerProp,
        TS.Constants.repeaterProp,
        'events', 'caller',
        'CommandCategories',
        'domainProperties',
        'modelUID',
        'rootUrl'
    ];

    var makeDate = function(s) {
        var date = new Date(s);
        return date;
    };
    if(isNaN(makeDate('2013-10-22T22:50:10.123Z')) || isNaN(makeDate('2013-10-22T22:50:10.12Z')))
        makeDate = function(s) {
            var year = parseInt(s.substr(0, 4), 10),
                month = parseInt(s.substr(5, 2), 10) - 1,
                day = parseInt(s.substr(8, 2), 10),
                hour = parseInt(s.substr(11, 2), 10),
                minute = parseInt(s.substr(14, 2), 10),
                second = parseInt(s.substr(17, 2), 10);

            var date = new Date(year, month, day, hour, minute, second);
            return date;
        };

    function isInternal(propName){

        if (typeof propName === 'string'){
            if(propName[0] === '$' || propName[0] === '_'){
                return true;
            }
        }

        if (internalProps.indexOf(propName) != -1){
            return true;
        }

        return false;
    }

    $.extend(TS,

    /** @lends module:TS */
    {

        bind: function(viewModel, rootNode) {
            console.time('bind');
            viewModel._isBinding = true;
            ko.applyBindings(viewModel, rootNode);
            viewModel._isBinding = false;

            viewModel._afterBind();
            console.timeEnd('bind');
        },

        convertModel: function(vm) {
            console.time('convertModel');
            var copyProps = [],
                mappingOptions = {
                    copy: ['domainProperties', 'CommandCategories', '_events', '__scope', 'messages'],
                    ignore: [TS.Constants.ownerProp]
                };
            //CP 20130522 - use ko.mapping.isMapped instead of ko.isObservable
            //was causing a stack overflow in the mapping plugin
            //see http://github.com/SteveSanderson/knockout.mapping/issues/160
            if (!ko.mapping.isMapped(vm)) {

                TS.makeDates(vm);

                //build model properties and return their names
                //to instruct the mapping plugin to copy them without conversion
                TS.buildModelProperties(vm);
                $.each(vm.domainProperties, function(idx, prop){
                    mappingOptions.copy.push(prop.name);
                });

                vm._beforeConvert(vm);
                vm = ko.mapping.fromJS(vm, mappingOptions);
                vm._afterConvert();

                // hook view model AFTER conversion
                // otherwise properties would hold a reference to a plain object (non-observable)
                $.each(vm.domainProperties, function(idx, prop){
                    prop.hookViewModel(vm);
                });

                vm._hookProperties();
            }

            console.timeEnd('convertModel');
            return vm;
        },

        isModelPropertyConfig: function(obj){
            if (!obj)
                return false;

            if (typeof obj === 'object' && typeof obj['propertyType'] != 'undefined'){
                return true;
            }

            return false;
        },

        buildModelProperties: function(vm) {
            var key,
                propVal,
                propNames = [];

            for (key in vm) {

                if (isInternal(key)){
                    continue;
                }

                propVal = vm[key];

                if (TS.isModelPropertyConfig(propVal)){
                    propVal = TS.ObjectFactory.createObject(propVal['propertyType'], propVal);
                    vm[key] = propVal;
                    vm.domainProperties.push(propVal);
                    propNames.push(key);
                }

                if (TS.isDateString(propVal)) {
                    vm[key] = makeDate(propVal);
                }

                if (typeof (propVal) === 'object') {
                    TS.makeDates(propVal);
                }
            }

            return propNames;
        },

        //naive method of determining whether a string represents a DateTime
        isDateString: function(str) {
            //"2013-05-15T21:00:00Z"
            //"2013-08-16T08:39:30.59Z"
            //"2013-08-16T08:39:30.129Z"
            if (typeof (str) !== 'string')
                return false;

            var len = str.length;

            //if (len < 20 || len > 24)
            //    return false;

            if (str.charAt(10) !== 'T' ||
                str.charAt(4) !== '-' ||
                str.charAt(7) !== '-' ||
                str.charAt(13) !== ':' ||
                str.charAt(16) !== ':')
                return false;

            //if (str.charAt(len - 1) !== 'Z')
            //    return false;


            return true;
        },

        //converts strings such as "2013-05-15T21:00:00Z" to Date objects
        makeDates: function(obj) {
            var key,
                propVal;

            for (key in obj) {

                if (isInternal(key)){
                    continue;
                }

                propVal = obj[key];
                if (TS.isDateString(propVal)) {
                    obj[key] = makeDate(propVal);
                }

                if (typeof (propVal) === 'object' && propVal != null && propVal.constructor === Object) {
                    TS.makeDates(propVal);
                }
            }
            return obj;
        },

        ensureValue: function(object, prop, defaultValue){
            if (!object.hasOwnProperty(prop) || object[prop] === undefined){
                object[prop] = defaultValue;
            }
        },

        /**
         * Creates an observable property for an object, with an optional default value.
         * @param object {Object} Target object
         * @param prop {String} Property name
         * @param [defaultValue] {*} Default value
         * @static
         *
         * @example
         *
         * var person = {};
         *
         * TS.makeObservable(person, 'firstName', '');
         *
         * me.watchProperty(person.firstName, function(newValue){
         *      console.log('firstName changed to: ' + newValue);
         * });
         *
         */
        makeObservable: function(object, prop, defaultValue){
            TS.ensureValue(object, prop, defaultValue);
            object[prop] = ko.observable(object[prop]);
        }
    });

    TS.isInternal = isInternal;

	var preProcessBindings = ko.expressionRewriting.preProcessBindings,
		tsPreProcessBindings = function (bindingsStringOrKeyValueArray, bindingOptions) {
			var koResult = preProcessBindings(bindingsStringOrKeyValueArray, bindingOptions);
			return koResult;
		};

	ko.exportSymbol('expressionRewriting.preProcessBindings', tsPreProcessBindings);

})();
